import React from "react";
import PageIntro from "../components/PageIntro";
import securityData from "../content/security_tips.json";

const SecurityTips = () => {
  return (
    <>
      <PageIntro
        title={securityData.title}
        subtitle=""
        compactBottom
        contentWidthClass="max-w-[1400px]"
        bottomPadding="pb-4 md:pb-6"
      ></PageIntro>
      <section className="bg-ofWhite overflow-hidden pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
          {/* Intro */}
          <div className="mb-8">
            {securityData.intro.map((text, index) => (
              <p key={index} className="mb-2 text-gray-700">
                {text}
              </p>
            ))}
          </div>

          {/* DO's */}
          <div className="mb-10">
            <h2 className="text-2xl font-semibold mb-4 text-green-700">
              {securityData.dos.title}
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              {securityData.dos.items.map((item, index) => (
                <li key={index} className="text-gray-700">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* DON'Ts */}
          <div className="mb-10">
            <h2 className="text-2xl font-semibold mb-4 text-red-700">
              {securityData.donts.title}
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              {securityData.donts.items.map((item, index) => (
                <li key={index} className="text-gray-700">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Tips */}
          <div>
            <h2 className="text-2xl font-semibold mb-4">
              {securityData.tips.title}
            </h2>

            <p className="mb-6 text-gray-700">
              {securityData.tips.description}
            </p>

            {securityData.tips.list.map((tip) => (
              <div key={tip.id} className="mb-6">
                <h3 className="text-xl font-semibold mb-2">
                  {tip.id}. {tip.title}
                </h3>

                {/* Normal Description */}
                {tip.description && (
                  <p className="text-gray-700 mb-2">{tip.description}</p>
                )}

                {/* Points */}
                {tip.points && (
                  <ul className="list-disc pl-6 space-y-1">
                    {tip.points.map((point, index) => (
                      <li key={index} className="text-gray-700">
                        {point}
                      </li>
                    ))}
                  </ul>
                )}

                {/* Frauds List */}
                {tip.frauds && (
                  <ul className="grid grid-cols-1 md:grid-cols-3 gap-3 border border-gray-300 rounded-lg p-3">
                    {tip.frauds.map((fraud, index) => (
                      <li
                        key={index}
                        className="border border-gray-200 rounded-md p-2 text-gray-700 bg-white"
                      >
                        {fraud}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default SecurityTips;
